import { ToastContainer as ToastContaineBase } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ToastContainer() {
  return <ToastContaineBase position="top-center" />;
}

export { ToastContainer };
